define("Magento_Catalog/js/product/view/product-ids",["ko"],function(e){"use strict";return e.observableArray([])});
